/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ISortBy {
  Newest = 'newest',
  TopRated = 'topRated',
  Easiest = 'easiest',
  Hardest = 'hardest',
  Shortest = 'shortest',
  Longest = 'longest',
  Distance = 'distance',
  Calories = 'calories',
  Trending = 'trending',
  Relevance = 'relevance',
  Alphabetical = 'alphabetical',
}
